import { PaintRowDraft } from '../types'

/** Эталон бренда — рецепт без версии. */
export function getBrandReference(draft: PaintRowDraft, manufacturerDocumentId: string) {
    return draft.versions[manufacturerDocumentId]?.find(pantone => pantone.version == null) ?? null
}
